import { FormEvent, useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./ajouterCommercial.css";
import { MagasinContext } from "../../../Context/MagasinContext";
import GetGommercialById from "../../../Services/Admin/GetCommercialById";
import { CommercialInfo } from "../../../Modeles/Commercial";
import axios from "axios";
import { NewSideBarMagasins } from "../../NewSidebarMagasin";

export interface CommandeType {
  Commercial: CommercialInfo[];
  messageErrosCommercial: string;
}

export default function AfficheCommercial() {
  const handleGoBack = () => window.history.back();
  const navigate = useNavigate();
  const params = useParams();
  const magasinContext = useContext(MagasinContext);
  const MagasinId = localStorage.getItem("MagasinId");

  const pathParts = window.location.pathname.split("/").filter(Boolean);
  const magIndex = pathParts.indexOf("magasins") !== -1 ? pathParts.indexOf("magasins") : pathParts.indexOf("magasin");
  const urlMagId = magIndex !== -1 && pathParts[magIndex + 1] ? pathParts[magIndex + 1] : null;
  const comIndex = pathParts.indexOf("commercials") !== -1 ? pathParts.indexOf("commercials") : pathParts.indexOf("commercial");
  const urlComId = comIndex !== -1 && pathParts[comIndex + 1] ? pathParts[comIndex + 1] : null;

  const idMag = urlMagId || MagasinId || magasinContext.id?.id || (params as any).idMag || params.id;
  const id = urlComId || (params as any).commercialId || (params as any).idCommercial || params.id;

  const [Remise, setRemise] = useState<string>("");
  const [email, setemail] = useState<string>("");
  const [Tele, settele] = useState<string>("");
  const [Nom, setNom] = useState<string>("");
  const [Prenom, setPrenom] = useState<string>("");
  const [password, setpassword] = useState<string>("");
  const [Credit, setCredit] = useState<string>("");
  const [Cin, setCin] = useState<string>("");
  const [Ville, setVille] = useState<string>("");
  const [Message, setMessage] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const [stateCommercial, setstateCommercial] = useState<CommandeType>({
    Commercial: [] as CommercialInfo[],
    messageErrosCommercial: "Aucun commercial trouvé",
  });

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    GetGommercialById(id, idMag)
      .GetCommercial()
      .then((res) => {
        const comData = Array.isArray(res.data) ? res.data[0] : res.data;
        if (comData) {
          setNom(comData.Nom || "");
          setPrenom(comData.Prenom || "");
          setemail(comData.Email || comData.email || "");
          setpassword(comData.Password || comData.password || "");
          settele(comData.Tele || comData.tele || "");
          setRemise(comData.RemiseGlobal ?? comData.Remise ?? "");
          setCredit(comData.Credit ?? "");
          setCin(comData.Cin ?? comData.cin ?? "");
          setVille(comData.Ville ?? comData.ville ?? "");
        }
        setstateCommercial({
          ...stateCommercial,
          Commercial: Array.isArray(res.data) ? res.data : (res.data ? [res.data] : []),
        });
        setLoading(false);
      })
      .catch((error) => {
        setstateCommercial({
          ...stateCommercial,
          messageErrosCommercial: error?.messageErrosCommercial || "Erreur de chargement",
        });
        setLoading(false);
      });
  }, [id, idMag]);

  const { Commercial, messageErrosCommercial } = stateCommercial;

  const handleSubmitUpdate = async (e: FormEvent) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setMessage("");

    try {
      const formData = new FormData();
      formData.append("_method", "post");
      formData.append("Nom", Nom);
      formData.append("Prenom", Prenom);
      formData.append("Tele", Tele);
      formData.append("Email", email);
      formData.append("Password", password);
      formData.append("Remise", Remise);
      formData.append("Credit", Credit);
      formData.append("Cin", Cin);
      formData.append("Ville", Ville);

      await axios.post(
        `${process.env.REACT_APP_PHP_APP_URL}/magasins/${idMag}/commercials/${id}/edite`,
        formData
      );

      setMessage("Commercial modifié avec succès");
      setTimeout(() => {
        setMessage("");
        navigate(`/magasins/${idMag}/commercials`);
      }, 2000);
    } catch (err) {
      console.error("Error updating commercial:", err);
    } finally {
      setSubmitting(false);
    }
  };

  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ─── MOBILE VIEW ─────────────────────────────── */
  if (screenWidth <= 450) {
    return (
      <>
        <NewSideBarMagasins />

        {loading ? (
          <div className="loader-wrapper-acmu">
            <div className="custom-spinner-acmu" role="status" />
            <span className="loader-charg-acmu">Chargement...</span>
          </div>
        ) : (
          <div className="page-wrapper-acmu">
            {Commercial && Commercial.length > 0 ? (
              Commercial.map((com: any) => (
                <form key={com.id || com.IdCommercial} onSubmit={handleSubmitUpdate}>

                  {/* Back + title */}
                  <div className="bar-retour-acmu">
                    <Link to="" onClick={handleGoBack} className="icon-retour-acmu">
                      <i className="bi bi-arrow-left-short" />
                    </Link>
                    <div className="marque-acmu" style={{ marginBottom: 0 }}>
                      <h4>{com.Prenom} {com.Nom}</h4>
                    </div>
                  </div>

                  {/* Alert */}
                  {Message !== "" && (
                    <div className="alert-success-acmu">
                      <i className="bi bi-check2-circle" /> {Message}
                    </div>
                  )}

                  {/* Form */}
                  <div className="form-card-acmu">
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Prénom</label>
                      <input type="text" defaultValue={com.Prenom} onChange={(e) => setPrenom(e.target.value)} className="form-control-acmu" />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Nom</label>
                      <input type="text" defaultValue={com.Nom} onChange={(e) => setNom(e.target.value)} className="form-control-acmu" />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Email</label>
                      <input type="text" defaultValue={com.Email || com.email} onChange={(e) => setemail(e.target.value)} className="form-control-acmu" />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Mot de passe</label>
                      <input type="text" defaultValue={com.Password} onChange={(e) => setpassword(e.target.value)} className="form-control-acmu" />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Téléphone</label>
                      <input type="text" defaultValue={com.Tele} onChange={(e) => settele(e.target.value)} className="form-control-acmu" />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">CIN</label>
                      <input type="text" defaultValue={com.Cin} onChange={(e) => setCin(e.target.value)} className="form-control-acmu" />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Ville</label>
                      <input type="text" defaultValue={com.Ville || com.ville} onChange={(e) => setVille(e.target.value)} className="form-control-acmu" />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Remise (%)</label>
                      <input type="text" defaultValue={com.RemiseGlobal ?? com.Remise ?? ""} onChange={(e) => setRemise(e.target.value)} className="form-control-acmu" />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Solde (MAD)</label>
                      <input type="number" defaultValue={com.Credit} onChange={(e) => setCredit(e.target.value)} className="form-control-acmu" />
                    </div>
                  </div>
                  <div className="btn-submit-wrap-acmu">
                    <button className="btn-submit-mobile-acmu" type="submit" disabled={submitting}>
                      {submitting ? "Modification en cours..." : "Modifier"}
                    </button>
                  </div>
                </form>
              ))
            ) : (
              <p>{messageErrosCommercial}</p>
            )}
          </div>
        )}
      </>
    );
  }

  /* ─── DESKTOP VIEW ────────────────────────────── */
  return (
    <>
      <NewSideBarMagasins />
      {loading ? (
        <div className="loader-wrapper-acmu">
          <div className="custom-spinner-acmu" role="status" />
          <span className="loader-charg-acmu">Chargement...</span>
        </div>
      ) : (
        <div className="page-wrapper-acmu">
          {Commercial && Commercial.length > 0 ? (
            Commercial.map((com: any) => (
              <form key={com.id || com.IdCommercial} onSubmit={handleSubmitUpdate}>

                {/* Back + title */}
                <div className="bar-retour-acmu">
                  <Link to="" onClick={handleGoBack} className="icon-retour-acmu">
                    <i className="bi bi-arrow-left-short" />
                  </Link>
                  <div className="marque-acmu" style={{ marginBottom: 0 }}>
                    <h4>{com.Prenom} {com.Nom}</h4>
                  </div>
                </div>

                {/* Alert */}
                {Message !== "" && (
                  <div className="alert-success-acmu">
                    <i className="bi bi-check2-circle" /> {Message}
                  </div>
                )}

                {/* Form */}
                <div className="form-card-acmu">
                  <div className="form-row-ajcmu">
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Prénom</label>
                      <input type="text" defaultValue={com.Prenom} onChange={(e) => setPrenom(e.target.value)} className="form-control-acmu" />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Nom</label>
                      <input type="text" defaultValue={com.Nom} onChange={(e) => setNom(e.target.value)} className="form-control-acmu" />
                    </div>
                  </div>

                  <div className="form-row-ajcmu">
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Email</label>
                      <input type="text" defaultValue={com.Email || com.email} onChange={(e) => setemail(e.target.value)} className="form-control-acmu" />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Mot de passe</label>
                      <input type="text" defaultValue={com.Password} onChange={(e) => setpassword(e.target.value)} className="form-control-acmu" />
                    </div>
                  </div>

                  <div className="form-row-ajcmu">
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Téléphone</label>
                      <input type="text" defaultValue={com.Tele} onChange={(e) => settele(e.target.value)} className="form-control-acmu" />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">CIN</label>
                      <input type="text" defaultValue={com.Cin} onChange={(e) => setCin(e.target.value)} className="form-control-acmu" />
                    </div>
                  </div>

                  <div className="form-row-ajcmu">
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Ville</label>
                      <input type="text" defaultValue={com.Ville || com.ville} onChange={(e) => setVille(e.target.value)} className="form-control-acmu" />
                    </div>
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Remise (%)</label>
                      <input type="text" defaultValue={com.RemiseGlobal ?? com.Remise ?? ""} onChange={(e) => setRemise(e.target.value)} className="form-control-acmu" />
                    </div>
                  </div>

                  <div className="form-row-ajcmu">
                    <div className="form-group-acmu">
                      <label className="form-label-acmu">Solde (MAD)</label>
                      <input type="number" defaultValue={com.Credit} onChange={(e) => setCredit(e.target.value)} className="form-control-acmu" />
                    </div>
                    <div className="form-group-acmu">
                      {/* Layout balance */}
                    </div>
                  </div>

                  <div className="btn-submit-wrap-acmu">
                    <button className="btn-submit-acmu" type="submit" disabled={submitting} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8, opacity: submitting ? 0.75 : 1 }}>
                      {submitting ? (
                        <>
                          <span style={{ width: 16, height: 16, display: 'inline-block', border: '2.5px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', borderRadius: '50%', animation: 'spinC 0.65s linear infinite' }}></span>
                          Modification en cours...
                        </>
                      ) : (
                        <>
                          <i className="bi bi-pencil-square" /> Modifier
                        </>
                      )}
                    </button>
                    <style>{`@keyframes spinC { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                  </div>
                </div>
              </form>
            ))
          ) : (
            <p style={{ textAlign: "center", marginTop: 60, color: "var(--text-secondary-acmu)" }}>
              {messageErrosCommercial}
            </p>
          )}
        </div>
      )}
    </>
  );
}